import React, { useRef } from "react";
import { Form, Formik } from "formik";
import Select from "~components/Form/components/Select";
import { useNavigate } from "react-router-dom";
import { ModalClosed } from "~misc/icons";
import MaskedInput from "react-text-mask";
import InputField from "~components/Form/components/InputField";
import "./index.scss";
import mask from "~services/utils/mask";
import Loader from "~components/Form/components/Loader";
import * as yup from "yup";
import { contatoValidation } from "~services/utils/defaultValidations";
import { useToast } from "@chakra-ui/react";
import useOnlineStatus from "~hooks/useOnlineStatus";

const contatoModalValidation = yup.object().shape({
  ...contatoValidation(),
  cargoId: yup.number().nullable().required("O cargo é obrigatório!"),
  celular: yup
    .string()
    .test("contatos.celular", "Celular incompleto!", function (value) {
      if (!value) return true;

      return contatoValidation().celular.isValidSync(value);
    }),
});

const validation = yup.object().shape({
  contatos: yup.array().of(contatoModalValidation),
  simulador: yup.number().nullable()
});

const buildTouchedContatos = (contatos = []) => ({
  contatos: contatos.map(() => ({
    nome: true,
    sobrenome: true,
    cargoId: true,
    email: true,
    telefone: true,
    celular: true,
  })),
});

const hasValidationErrors = (value) => {
  if (!value) return false;
  if (typeof value === "string") return true;
  if (Array.isArray(value)) return value.some(hasValidationErrors);
  if (typeof value === "object") return Object.values(value).some(hasValidationErrors);
  return false;
};

const ModalContato = ({
  isOpen,
  onClose,
  emissorData,
  optionsCargo,
  setinitialValues,
  selectedContact,
  setSelectedContact,
  initialValues,
  openModalContatoSalvar,
  formModalValuesCreate, setFormModalValuesCreate
}) => {
  const isOnline = useOnlineStatus();
  const modalClasses = isOpen
    ? "fixed inset-0 bg-black bg-opacity-0 z-[99999]"
    : "hidden";
  const overlayClasses = isOpen
    ? "fixed inset-0 bg-black opacity-50 z-40"
    : "hidden";
  const formikRef = useRef();
  const { formatNumber } = mask();
const toast = useToast();
const adicionarContato = (novoContato) => {
  setinitialValues((prev) => {
    const maiorId = prev.contatos.length
      ? Math.max(...prev.contatos.map(c => c.id))
      : -1;

    const contatoComId = {
      ...novoContato,
      id: maiorId + 1,
    };

     toast({
        title: `Contato adicionado com sucesso!`,
        description: "",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right"
      });

    return {
      ...prev,
      contatos: [...prev.contatos, contatoComId],
    };
  });
};


  const initial = React.useMemo(() => {
    if (selectedContact && Object.keys(selectedContact).length > 0) {
      return { contatos: [selectedContact] };
    }
    return {
      contatos: [
        {
          id: 0,
          nome: "",
          sobrenome: "",
          cargoId: null,
          email: "",
          telefone: "",
          celular: "",
        },
      ],
    };
  }, [selectedContact]);



  const handleClose = (resetForm) => {
    resetForm({ values: initial });
    setSelectedContact({});
    onClose();
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initial}
      enableReinitialize
      validationSchema={validation}
     onSubmit={async (values, { resetForm }) => {
        const [contato] = values.contatos;
        const contatoComIdRandom = {
          ...contato,
          idRandom: crypto.randomUUID(),
        };

        setFormModalValuesCreate((prev) => {
          const contatosAtuais = prev.contatos || [];

          return {
            ...prev,
            contatos: [...contatosAtuais, contatoComIdRandom],
          };
        });

        toast({
          title: "Novo contato adicionado!",
          description: "Para manter as alterações, não esqueça de enviar o formulário.",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top-right",
        });

        resetForm({ values: initial });
        onClose();
      }}

    >
      {({ values, errors, touched, setFieldValue, setFieldTouched, setFieldError, resetForm, setTouched, validateForm, submitForm, isSubmitting }) => (
        <Form className={modalClasses}>
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="bg-white min-w-[680px] px-14 py-14 rounded-[20px] shadow-lg z-50 relative">
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => handleClose(resetForm)}
                  className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
                >
                  <ModalClosed />
                </button>
              </div>

              <h3 className="font-bold text-3xl max-w-[600px] mx-auto mb-4">
                Novo Contato
              </h3>

              <div className="relative rounded-lg grid gap-x-4 grid-cols-1">
                <InputField
                  className="bg-white"
                  labelName="Nome Contato:"
                  inputName="contatos[0].nome"
                  inputMask="offmask"
                  inputType="text"
                  difference={true}
                  isRequired={emissorData.tipo !== 1}
                />

                <InputField
                  labelName="Sobrenome Contato:"
                  inputName="contatos[0].sobrenome"
                  inputMask="offmask"
                  inputType="text"
                  isRequired={emissorData.tipo !== 1}
                  difference={true}
                />

                <Select
                  name="contatos[0].cargoId"
                  label="Cargo:"
                  placeholder=""
                  options={optionsCargo}
                  onChange={(e) => {
                    setFieldValue("contatos[0].cargoId", e?.value ?? null, false);
                    setFieldValue("contatos[0].cargo", e?.label ?? "", false);
                    setFieldTouched("contatos[0].cargoId", true, false);
                    setFieldError("contatos[0].cargoId", undefined);
                  }}
                   value={optionsCargo.find(opt => opt.value === values.contatos?.[0]?.cargoId) || null}
                  errors={errors.contatos?.[0]?.cargoId}
                  touched={touched.contatos?.[0]?.cargoId}
                  isRequired={emissorData.tipo !== 1}
                />

                <InputField
                  labelName="Email do Contato:"
                  inputName="contatos[0].email"
                  inputMask="offmask"
                  inputType="text"
                  isRequired={emissorData.tipo !== 1}
                  difference={true}
                />

                <InputField
                  labelName="Telefone de contato 1:"
                  inputName="contatos[0].telefone"
                  as={MaskedInput}
                  mask={formatNumber}
                  inputMask="onmask"
                  inputType="text"
                  isRequired={emissorData.tipo !== 1}
                  difference={true}
                />

                <InputField
                  labelName="Telefone de contato 2:"
                  inputName="contatos[0].celular"
                  as={MaskedInput}
                  mask={formatNumber}
                  inputMask="onmask"
                  inputType="text"
                  difference={true}
                />
              </div>

              <div>
                <div className="flex items-center justify-between">
                  <button
                    type="button"
                    className="mt-4 py-2 px-3 bg-[#EA3901] text-white opacity-100 rounded-lg font-bold text-[13px] button-search"
                    onClick={() => handleClose(resetForm)}
                    disabled={isSubmitting}
                  >
                    Cancelar
                  </button>

                  {isOnline ? (
                    <button
                      type="button"
                      className="mt-4 py-2 px-3 bg-secundaria text-white opacity-100 rounded-lg font-bold text-[13px] button-search min-w-[128px] flex items-center justify-center gap-2 disabled:opacity-70"
                      disabled={isSubmitting}
                      onClick={async () => {
                        if (isSubmitting) {
                          return;
                        }

                        await setTouched(buildTouchedContatos(values.contatos), true);
                        const validationErrors = await validateForm();
                        if (hasValidationErrors(validationErrors)) {
                          return;
                        }
                        await submitForm();
                      }}
                    >
                      {isSubmitting ? <Loader /> : "Salvar Dados"}
                    </button>
                  ) : null}
                </div>
              </div>
            </div>

            <div
              className={overlayClasses}
              onClick={() => handleClose(resetForm)}
            ></div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ModalContato;